import React, { useState, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import Header from "../ShareElements/ContentHeader/ContentHeader";
import Circle from "../../../../Assets/Images/sm-Circle.svg";
import SearchInput from "../ShareElements/SearchInput/SearchInput";
import TableFilter from "../ShareElements/TableFilter/TableFilter";
import "../../../../Assets/Styles/EmpPosList.scss";
import "../../../../Assets/Styles/Pagination.scss";
import { Config } from "../../../../Config";
import Pencil from "../../../../Assets/Images/pencil.svg";
import axios from "axios";
import EmptyState from "../ShareElements/EmptyState/FormEmptyState";
import Collapsible from "react-collapsible";
import Select from "../ShareElements/Select/Select";

const PositionsList = (props) => {
  const [PageData, setPageData] = useState([]);
  const [Pages, setPages] = useState([1]);
  const [TotalElements, setTotalElements] = useState();
  const [FilterIds] = useState([
    "Position-sort-pointer-up",
    "Position-sort-pointer-down",
    "PrimaryIncumbent-sort-pointer-up",
    "PrimaryIncumbent-sort-pointer-down",
    "Country-sort-pointer-up",
    "Country-sort-pointer-down",
    "Department-sort-pointer-up",
    "Department-sort-pointer-down",
  ]);
  const [SizeOptions] = useState([
    { name: 5, id: 5 },
    { name: 10, id: 10 },
    { name: 15, id: 15 },
    { name: 20, id: 20 },
    { name: 25, id: 25 },
    { name: 50, id: 50 },
  ]);
  const [MobileSortIds] = useState([
    "Position-sort",
    "PrimaryIncumbent-sort",
    "Country-sort",
    "Department-sort",
  ]);
  var PrevId = "";
  var PreviousModalId;

  const [PageInfo, setPageInfo] = useState({});
  const [ResultIsEmpty, setResultIsEmpty] = useState(false);

  useEffect(() => {
    fetchPosList(0, 5);
    document.getElementById("Position-sort").classList.add("active-sort");
  }, []);

  const fetchPosList = (Start, Size) => {
    let Data = {
      criteria: {
        titleLike: document.getElementById("search-input").value,
        primaryEmployee: true,
      },
      start: Start,
      size: Size,
      sorts: [
        {
          fieldName: "title",
          direction: "ASC",
        },
      ],
    };

    if (
      document
        .getElementById("Position-sort-pointer-up")
        .classList.contains("active-filter") ||
      document
        .getElementById("Position-sort-pointer-down")
        .classList.contains("active-filter")
    ) {
      if (
        document
          .getElementById("Position-sort-pointer-up")
          .classList.contains("active-filter")
      ) {
        Data.sorts = [
          {
            fieldName: "title",
            direction: "DESC",
          },
        ];
      } else {
        Data.sorts = [
          {
            fieldName: "title",
            direction: "ASC",
          },
        ];
      }
    }
    if (
      document
        .getElementById("PrimaryIncumbent-sort-pointer-up")
        .classList.contains("active-filter") ||
      document
        .getElementById("PrimaryIncumbent-sort-pointer-down")
        .classList.contains("active-filter")
    ) {
      if (
        document
          .getElementById("PrimaryIncumbent-sort-pointer-up")
          .classList.contains("active-filter")
      ) {
        Data.sorts = [
          {
            fieldName: "assignments.employee.firstName",
            direction: "DESC",
          },
        ];
      } else {
        Data.sorts = [
          {
            fieldName: "assignments.employee.firstName",
            direction: "ASC",
          },
        ];
      }
    }
    if (
      document
        .getElementById("Country-sort-pointer-up")
        .classList.contains("active-filter") ||
      document
        .getElementById("Country-sort-pointer-down")
        .classList.contains("active-filter")
    ) {
      if (
        document
          .getElementById("Country-sort-pointer-up")
          .classList.contains("active-filter")
      ) {
        Data.sorts = [
          {
            fieldName: "country.name",
            direction: "DESC",
          },
        ];
      } else {
        Data.sorts = [
          {
            fieldName: "country.name",
            direction: "ASC",
          },
        ];
      }
    }

    if (
      document
        .getElementById("Department-sort-pointer-up")
        .classList.contains("active-filter") ||
      document
        .getElementById("Department-sort-pointer-down")
        .classList.contains("active-filter")
    ) {
      if (
        document
          .getElementById("Department-sort-pointer-up")
          .classList.contains("active-filter")
      ) {
        Data.sorts = [
          {
            fieldName: "department.name",
            direction: "DESC",
          },
        ];
      } else {
        Data.sorts = [
          {
            fieldName: "department.name",
            direction: "ASC",
          },
        ];
      }
    }

    if (TotalElements !== undefined && parseInt(Start) > TotalElements) {
      Start = parseInt(TotalElements - Size);
      Data.start = parseInt(TotalElements - Size);
    }

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL + Config.PositionMngURL + "/api/position/search",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        if (Res.data.results.length === 0) {
          setResultIsEmpty(true);
          document.getElementById("info-footer").style.opacity = "0";
        } else {
          setResultIsEmpty(false);
          document.getElementById("info-footer").style.opacity = "1";
        }
        if (Res.data.totalElements <= Size) {
          document
            .getElementById("next-page")
            .classList.add("page-btn-disabled");
          document
            .getElementById("prev-page")
            .classList.add("page-btn-disabled");
          document.getElementById("end").innerHTML = Res.data.totalElements;
        }
        updatePageCountInfo(Start, Size, Res.data.totalElements);
        setPageData(Res.data.results);
        setTotalElements(Res.data.totalElements);
        createPagination(Res.data.totalElements);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const handleFilterRequest = (Filter) => {
    let SelectedSize = parseInt(
      document.getElementById("pre-selected-row-per-page").innerHTML
    );
    let IsUp = false;
    if (
      document
        .getElementById(Filter + "-pointer-up")
        .classList.contains("active-filter")
    ) {
      IsUp = true;
    }

    FilterIds.map((Id) => {
      document.getElementById(Id).classList.remove("active-filter");
    });
    if (IsUp) {
      document
        .getElementById(Filter + "-pointer-up")
        .classList.add("active-filter");
    } else {
      document
        .getElementById(Filter + "-pointer-down")
        .classList.add("active-filter");
    }
    let Start = parseInt(document.getElementById("start").innerHTML - 1);

    if (window.innerWidth <= 450) {
      MobileSortIds.map((Id) => {
        document.getElementById(Id).classList.remove("active-sort");
      });
      if (Filter === "Position-sort") {
        document.getElementById("Position-sort").classList.add("active-sort");
      }
      if (Filter === "Country-sort") {
        document.getElementById("Country-sort").classList.add("active-sort");
      }
      if (Filter === "PrimaryIncumbent-sort") {
        document
          .getElementById("PrimaryIncumbent-sort")
          .classList.add("active-sort");
      }
      if (Filter === "Department-sort") {
        document.getElementById("Department-sort").classList.add("active-sort");
      }
    }

    fetchPosList(Start, SelectedSize);
  };
  const shortenPosName = (Name) => {
    if (Name.length <= 26) {
      return Name;
    } else {
      return Name.slice(0, 23) + " ...";
    }
  };
  const requestPageNumber = (PageNumber) => {
    let Size = parseInt(
      document.getElementById("pre-selected-row-per-page").innerHTML
    );
    let NewStart = parseInt((PageNumber - 1) * Size);
    let SelectedSize = parseInt(
      document.getElementById("pre-selected-row-per-page").innerHTML
    );
    fetchPosList(NewStart, SelectedSize);

    if (NewStart === 0) {
      document.getElementById("start").innerHTML = 1;
    } else {
      document.getElementById("start").innerHTML = NewStart + 1;
    }
    if (NewStart + Size > TotalElements) {
      let Difference = parseInt(TotalElements - NewStart);
      document.getElementById("end").innerHTML = parseInt(
        NewStart + Difference
      );
      document.getElementById("next-page").classList.add("page-btn-disabled");
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    } else {
      document.getElementById("end").innerHTML = parseInt(NewStart + Size);
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    }
    if (PageNumber === 1) {
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
      document.getElementById("prev-page").classList.add("page-btn-disabled");
    }
    updateActiveClass(PageNumber);
    updatePaginationlength(PageNumber);
  };
  const updateActiveClass = (PageNumber) => {
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        document
          .getElementById(i + "-page-btn")
          .classList.remove("active-page");
      }
    }
    if (document.getElementById(PageNumber + "-page-btn") !== null) {
      if (PageNumber === 3) {
        document.getElementById(3 + "-page-btn").classList.add("active-page");
      } else {
        document
          .getElementById(PageNumber + "-page-btn")
          .classList.add("active-page");
      }
    }
  };
  const requestNextPage = () => {
    let NextPage;
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        if (document.getElementById(i + "-page-btn").classList.length > 1) {
          NextPage = parseInt(i + 1);
        }
      }
    }
    if (document.getElementById(NextPage + "-page-btn") !== null) {
      document.getElementById(NextPage + "-page-btn").click();
    }
  };
  const requestPrevPage = () => {
    let PrevPage;
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        if (document.getElementById(i + "-page-btn").classList.length > 1) {
          if (i === 1) {
            PrevPage = 1;
          } else {
            PrevPage = parseInt(i - 1);
          }
        }
      }
    }
    if (document.getElementById(PrevPage + "-page-btn") !== null) {
      document.getElementById(PrevPage + "-page-btn").click();
    }
  };

  const createPagination = (TotalCount) => {
    let Size = parseInt(
      document.getElementById("pre-selected-row-per-page").innerHTML
    );
    let Count = Math.ceil(TotalCount / Size);
    let PagesArray = [];
    for (let i = 0; i < Count; i++) {
      PagesArray.push(i + 1);
    }
    setPages(PagesArray);
    shortenPagination(PagesArray);
  };

  const searchByName = () => {
    let Size = parseInt(
      document.getElementById("pre-selected-row-per-page").innerHTML
    );
    document.getElementById("next-page").classList.remove("page-btn-disabled");
    document.getElementById("prev-page").classList.add("page-btn-disabled");
    let SelectedSize = parseInt(
      document.getElementById("pre-selected-row-per-page").innerHTML
    );
    fetchPosList(0, SelectedSize);
    if (document.getElementById("search-input").value.length === 0) {
      document.getElementById("end").innerHTML = Size;
    }
  };

  const updatePageCountInfo = (Start, Size, totalElements) => {
    if (Start === 0) {
      document.getElementById("start").innerHTML = "1";
      document.getElementById("end").innerHTML = Size;
      updateActiveClass(1);
    } else {
      // document.getElementById("start").innerHTML = Start;
    }
    if (totalElements < parseInt(Start + Size) && totalElements !== 0) {
      document.getElementById("end").innerHTML = totalElements;
    }
  };

  const shortenPagination = (Pages) => {
    if (Pages.length > 0) {
      let LastPage = Pages.reduce((a, b) => {
        return Math.max(a, b);
      });
      let FirstPage = parseInt(Pages[0]);
      let MiddlePage = 3;
      let FirstDotsShown = false;
      let LastDotsShown = true;
      let ActivePage;

      for (let i = 1; i <= Pages.length; i++) {
        if (document.getElementById(i + "-page-btn") !== null) {
          if (
            document
              .getElementById(i + "-page-btn")
              .classList.contains("active-page")
          ) {
            ActivePage = i;
          }
        }
      }
      if (ActivePage < 3) {
        LastDotsShown = true;
      }
      if (ActivePage > 3) {
        FirstDotsShown = true;
        MiddlePage = ActivePage;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      if (ActivePage < MiddlePage && ActivePage > 3) {
        FirstDotsShown = true;
        LastDotsShown = true;
      }
      if (parseInt(LastPage - 3) >= ActivePage) {
        LastDotsShown = false;
      }
      if (ActivePage === 3) {
        FirstDotsShown = false;
        MiddlePage = 3;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      setPageInfo({
        FirstPage: FirstPage,
        FirstDotsShown: FirstDotsShown,
        MiddlePage: MiddlePage,
        LastDotsShown: LastDotsShown,
        LastPage: LastPage,
        ActivePage: ActivePage,
      });
    } else {
      setPageInfo({
        FirstPage: 1,
        FirstDotsShown: false,
        MiddlePage: 3,
        LastDotsShown: true,
        LastPage: 1,
        ActivePage: 1,
      });
    }
  };
  const updatePaginationlength = (PageNum) => {
    shortenPagination(Pages);
  };

  const resetFilters = () => {
    if (document.getElementById("clear-btn") !== null) {
      document.getElementById("clear-btn").click();
    }
  };

  const handleDropdown = (Id) => {
    document.getElementById(Id + "-trigger").click();
  };
  const addOpenState = (Id) => {
    document.getElementById(Id + "-icon").style.transform = "rotate(180deg)";
  };
  const removeOpenState = (Id) => {
    document.getElementById(Id + "-icon").style.transform = "none";
  };

  // Opens and closes the small modal displayed for each row in the table based on conditions
  const openModal = (i) => {
    PrevId = i;

    if (PreviousModalId !== undefined) {
      if (document.getElementById("modal-" + i).style.display === "block") {
        document.getElementById("modal-" + i).style.display = "none";
      } else if (
        document.getElementById("modal-" + i).style.display === "none" &&
        PreviousModalId === "modal-" + i
      ) {
        document.getElementById("modal-" + i).style.display = "block";
      } else {
        document.getElementById("modal-" + i).style.display = "block";
        document.getElementById(PreviousModalId).style.display = "none";
      }
    } else {
      document.getElementById("modal-" + i).style.display = "block";
    }
    PreviousModalId = "modal-" + i;
  };

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const setSize = () => {
    setTimeout(() => {
      if (document.getElementById("1-page-btn") !== null) {
        document.getElementById("1-page-btn").click();
      }
    }, 300);
  };

  return (
    <BrowserRouter>
      <div className="main-content emp-pos-list">
        <Header PageName={translateText("position_list")} />
        <div className="content-header">
          <div className="address">
            <p>{translateText("positions")}</p>
            <img src={Circle} alt="." />
            <p>{translateText("position_list")}</p>
          </div>
        </div>
        <div className="content-body">
          <SearchInput
            OnChange={() => searchByName()}
            Placeholder={translateText("search")}
          />
          <div className="info-wrapper">
            <section className="info-head pos-head">
              <TableFilter
                IsActive
                ChangeEvent={() => handleFilterRequest("Position-sort")}
                Name={translateText("position")}
                className="table-sort"
                Id="Position-sort"
              />
              <TableFilter
                ChangeEvent={() => handleFilterRequest("PrimaryIncumbent-sort")}
                Name={translateText("primary_incumbent")}
                className="table-sort"
                Id="PrimaryIncumbent-sort"
              />
              <TableFilter
                ChangeEvent={() => handleFilterRequest("Country-sort")}
                Name={translateText("country")}
                className="table-sort"
                Id="Country-sort"
              />
              <TableFilter
                ChangeEvent={() => handleFilterRequest("Department-sort")}
                Name={translateText("department")}
                className="table-sort"
                Id="Department-sort"
              />
              {/* <TableFilter
                ChangeEvent={() => null}
                Name={translateText("action")}
                className="table-sort"
                Id=""
                NoPointers
              /> */}
            </section>
            {ResultIsEmpty ? (
              <EmptyState
                StateName="position"
                ResetFilters={() => resetFilters()}
              />
            ) : (
              <React.Fragment>
                {PageData.map((Position) => (
                  <div className="row-item pos-row">
                    <section className="emp-info">
                      <section className="grid-info">
                        <button
                          onClick={() => handleDropdown(Position.id)}
                          className="info-trigger is-mobile"
                          id={Position.id + "-icon"}
                        >
                          <i className="feather-chevron-down"></i>
                        </button>
                        <p className="emp-name pos-name">
                          {shortenPosName(Position.title)}
                          {Position.title.length > 26 ? (
                            <p>{Position.title}</p>
                          ) : null}
                        </p>
                        <p className="emp-pos">
                          {"(" + Position.globalPositionCode + ")"}
                        </p>
                      </section>
                    </section>
                    <React.Fragment>
                      {window.innerWidth > 450 ? (
                        <React.Fragment>
                          {Position.assignments.length === 0 ||
                          Position.assignments[0].employee === null ? (
                            <section className="single-text">
                              <p>{translateText('vacant')}</p>
                            </section>
                          ) : (
                            <section className="single-text">
                              <p>
                                {Position.assignments[0].employee.firstName +
                                  " " +
                                  Position.assignments[0].employee.lastName}
                              </p>
                            </section>
                          )}
                          <section className="single-text">
                            <p>
                              {Position.country ? Position.country.name : null}
                            </p>
                          </section>
                          <section className="single-text">
                            <p>
                              {Position.department === null
                                ? "Not Specified"
                                : shortenPosName(Position.department.name)}

                              {Position.department !== null && Position.department.name.length > 26 ?
                                  <p className="popup-text">
                                    {Position.department.name}
                                  </p> : null
                              }
                            </p>
                          </section>
                          {/* <section className="action">
                            <button
                              className="more"
                              onClick={() => openModal(Position.id)}
                            ></button>
                            <div
                              className="modal-space"
                              id={"modal-" + Position.id}
                            >
                              <div
                                className="outline"
                                onClick={() => openModal(PrevId)}
                              ></div>
                              <div className="modal-body double-item">
                                <button className="btn">
                                  <img alt="" src={Pencil} />
                                  <div className="btn-text">
                                    <p>{translateText("action")}</p>
                                    <p>{translateText("action")}</p>
                                  </div>
                                </button>
                                <button className="btn">
                                  <img alt="" src={Pencil} />
                                  <div className="btn-text">
                                    <p>{translateText("action")}</p>
                                    <p>{translateText("action")}</p>
                                  </div>
                                </button>
                              </div>
                            </div>
                          </section> */}
                        </React.Fragment>
                      ) : (
                        <Collapsible
                          trigger={
                            <button
                              className="hidden"
                              id={Position.id + "-trigger"}
                            ></button>
                          }
                          onOpening={() => addOpenState(Position.id)}
                          onClosing={() => removeOpenState(Position.id)}
                        >
                          {Position.assignments.length === 0 ||
                          Position.assignments[0].employee === null ? (
                            <section className="single-text">
                              <p className="is-mobile">
                                {translateText("primary_incumbent")}
                              </p>
                              <p>{translateText('vacant')}</p>
                            </section>
                          ) : (
                            <section className="single-text">
                              <p className="is-mobile">
                                {translateText("primary_incumbent")}
                              </p>
                              <p>
                                {Position.assignments[0].employee.firstName +
                                  " " +
                                  Position.assignments[0].employee.lastName}
                              </p>
                            </section>
                          )}
                          <section className="single-text">
                            <p className="is-mobile">
                              {translateText("country")}
                            </p>
                            <p>
                              {Position.country ? Position.country.name : null}
                            </p>
                          </section>
                          <section className="single-text">
                            <p className="is-mobile">
                              {translateText("department")}
                            </p>
                            <p>
                              {Position.department === null
                                ? "Not Specified"
                                : shortenPosName(Position.department.name)}

                              {Position.department !== null && Position.department.name.length > 26 ?
                                  <p className="popup-text">
                                    {Position.department.name}
                                  </p> : null
                              }
                            </p>
                          </section>
                          {/* <section className="action">
                            <p className="is-mobile">
                              {translateText("action")}
                            </p>
                            <button
                              className="more"
                              onClick={() => openModal(Position.id)}
                            ></button>
                          </section> */}
                        </Collapsible>
                      )}
                      <div
                        className="modal-space is-mobile"
                        id={"modal-" + Position.id}
                      >
                        <div
                          className="outline"
                          onClick={() => openModal(PrevId)}
                        ></div>
                        <div className="modal-body double-item">
                          <button className="btn">
                            <img alt="" src={Pencil} />
                            <div className="btn-text">
                              <p>{translateText("action")}</p>
                              <p>{translateText("action")}</p>
                            </div>
                          </button>
                          <button className="btn">
                            <img alt="" src={Pencil} />
                            <div className="btn-text">
                              <p>{translateText("action")}</p>
                              <p>{translateText("action")}</p>
                            </div>
                          </button>
                        </div>
                      </div>
                    </React.Fragment>{" "}
                  </div>
                ))}
              </React.Fragment>
            )}
          </div>
          <div className="info-footer" id="info-footer">
            <div className="pagenumber-summary">
              {translateText("showing")} <p id="start">1</p>
              {translateText("to")} <p id="end">5</p>
              {translateText("of")} {TotalElements} {translateText("items")}.
            </div>
            <section className="pagination-holder">
              <button
                onClick={() => requestPrevPage()}
                id="prev-page"
                className="page-btn page-btn-disabled"
              >
                <i className="feather-chevron-left"></i>
              </button>
              <React.Fragment>
                {Pages.length < 6 ? (
                  <React.Fragment>
                    {Pages.map((Page) => (
                      <React.Fragment>
                        {Page === 1 ? (
                          <button
                            key={Page}
                            onClick={() => requestPageNumber(Page)}
                            className="page-btn active-page"
                            id={Page + "-page-btn"}
                          >
                            {Page}
                          </button>
                        ) : (
                          <button
                            key={Page}
                            onClick={() => requestPageNumber(Page)}
                            className="page-btn"
                            id={Page + "-page-btn"}
                          >
                            {Page}
                          </button>
                        )}
                      </React.Fragment>
                    ))}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <button
                      onClick={() => requestPageNumber(1)}
                      className="page-btn active-page"
                      id={1 + "-page-btn"}
                    >
                      {1}
                    </button>
                    {PageInfo.FirstDotsShown ? <p>...</p> : null}
                    <button
                      onClick={() =>
                        requestPageNumber(parseInt(PageInfo.MiddlePage - 1))
                      }
                      className="page-btn"
                      id={parseInt(PageInfo.MiddlePage - 1) + "-page-btn"}
                    >
                      {parseInt(PageInfo.MiddlePage - 1)}
                    </button>
                    {PageInfo.MiddlePage === PageInfo.LastPage ? null : (
                      <button
                        onClick={() => requestPageNumber(PageInfo.MiddlePage)}
                        className="page-btn"
                        id={PageInfo.MiddlePage + "-page-btn"}
                      >
                        {PageInfo.MiddlePage}
                      </button>
                    )}
                    {parseInt(PageInfo.MiddlePage + 1) >=
                    PageInfo.LastPage ? null : (
                      <button
                        onClick={() =>
                          requestPageNumber(parseInt(PageInfo.MiddlePage + 1))
                        }
                        className="page-btn "
                        id={parseInt(PageInfo.MiddlePage + 1) + "-page-btn"}
                      >
                        {parseInt(PageInfo.MiddlePage + 1)}
                      </button>
                    )}
                    {!PageInfo.LastDotsShown ? <p>...</p> : null}
                    <button
                      onClick={() => requestPageNumber(PageInfo.LastPage)}
                      className="page-btn"
                      id={PageInfo.LastPage + "-page-btn"}
                    >
                      {PageInfo.LastPage}
                    </button>
                  </React.Fragment>
                )}
              </React.Fragment>

              <button
                onClick={() => requestNextPage()}
                id="next-page"
                className="page-btn"
              >
                <i className="feather-chevron-right"></i>
              </button>
            </section>
            <div className="row-count-select">
              <p className="row-info">{translateText("rows_per_page")}</p>
              <Select
                Initial={"5"}
                Options={SizeOptions}
                IsWithId
                Id={"row-per-page"}
                ChangeHandler={() =>
                  setTimeout(() => {
                    setSize();
                  }, 100)
                }
                ValidationError=""
              />
            </div>
          </div>
        </div>
      </div>
    </BrowserRouter>
  );
};

export default PositionsList;
